import React, { forwardRef } from 'react';
import T from 'prop-types';

import Card from './Card';
import CardContent from './CardContent';
import CardHeader from './CardHeader';
import CardActions from './CardActions';

// eslint-disable-next-line prefer-arrow-callback
const SimpleCard = forwardRef(function SimpleCard(
  {
    children,
    headerLeft,
    headerRight,
    headerGutters,
    headerDisableGutters,
    contentGutters = 24,
    contentDisableGutters,
    actionsLeft,
    actionsRight,
    actionsGutters,
    actionsDisableGutters,
    className,
  },
  ref
) {
  return (
    <Card ref={ref} className={className}>
      {(headerLeft || headerRight) && (
        <CardHeader
          left={headerLeft}
          right={headerRight}
          gutters={headerGutters}
          disableGutters={headerDisableGutters}
        />
      )}

      <CardContent gutters={contentGutters} disableGutters={contentDisableGutters}>
        {children}
      </CardContent>

      {(actionsLeft || actionsRight) && (
        <CardActions
          left={actionsLeft}
          right={actionsRight}
          gutters={actionsGutters}
          disableGutters={actionsDisableGutters}
        />
      )}
    </Card>
  );
});

SimpleCard.propTypes = {
  children: T.node.isRequired,
  headerLeft: T.node,
  headerRight: T.node,
  headerGutters: T.oneOfType([T.number, T.string]),
  headerDisableGutters: T.bool,
  contentGutters: T.oneOfType([T.number, T.string]),
  contentDisableGutters: T.bool,
  actionsLeft: T.node,
  actionsRight: T.node,
  actionsGutters: T.oneOfType([T.number, T.string]),
  actionsDisableGutters: T.bool,
  className: T.string,
};

export default SimpleCard;
